import React, { useMemo } from "react";
import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons";
import { useTranslation } from "react-i18next";

import {
  getEffectiveRpqStatus,
  RPQ_WARNING_CONFIG,
} from "../helpers/clientRpqStatus";

const ClientRpqAlert = ({ form, ...props }) => {
  const { t } = useTranslation();

  const status = useMemo(
    () => getEffectiveRpqStatus(form?.values),
    [form?.values?.rpq, form?.values?.rpqStatus]
  );

  const warning = RPQ_WARNING_CONFIG[status];
  if (!warning) return null;

  return (
    <Alert
      icon={<IconAlertCircle size="1rem" />}
      title={t(warning.title)}
      color={warning.color}
      {...props}
    >
      {t(warning.message)}
    </Alert>
  );
};

export default ClientRpqAlert;
